import React from 'react';
import { Fade as MuiFade } from '@material-ui/core';

const Fade = props => <MuiFade {...props} />;

export default Fade;
